import React, { useMemo } from 'react';
import styles from './ProgressBar.module.css';

type ProgressBarProps = {
    value: number;
    total: number;
};

function ProgressBar({ value, total }: ProgressBarProps) {
    const progressPercentage = useMemo(() => (value / total) * 100, [value, total]);
    return (
        <div className={styles.container}>
            <div className={styles.fill} data-testid="progress" style={{ width: `${progressPercentage}%` }}>
                <div className={styles.progressFill} />
            </div>
        </div>
    );
}

export default ProgressBar;
